// import React, { useRef, useState } from 'react';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
// import { Bar, Doughnut, Pie } from 'react-chartjs-2';
// import { BiDotsHorizontalRounded } from 'react-icons/bi';
// import { setDynamicModalObj } from '../../store/board.actions';

// ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// export function LabelChart({ board, dynamicModalObj }) {
//   const elModalBtn = useRef();
//   const [chartType, setChartType] = useState('bar');


//   // Mapeo de estados
//   const estadoMap = {
//     1: 'No iniciada',
//     2: 'En proceso',
//     3: 'Terminada',
//     4: 'No se Realizara',
//     5: 'Iniciada',
//   };
  

//   const data = {
//     labels: getLabelTitles(),
//     datasets: [
//       {
//         label: 'Estados de actividades',
//         data: getData(),
//         backgroundColor: getLabelColors(),
//         borderColor: getLabelColors(),
//         borderWidth: 1,
//       },
//     ],
//   };

//   function getLabelTitles() {
//     // Extrae los títulos (nombres) de los estados
//     return Object.values(estadoMap);
//   }

//   function getLabelColors() {
//     // Define colores para los estados, incluyendo un color para "otros"
//     return ['#df2f4a', '#fcab3c', '#00c875', '#4b4c6a', '#0073EA']; // Puedes personalizarlos
//   }
  

//   function getData() {
//     // Inicializa los conteos de estados
//     const stateCounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  
//     // Recorre los grupos y actividades para contar los estados
//     board.forEach((group) => {
//       group.actividades.forEach((actividad) => {
//         const estadoId = actividad.fk_estado_id;
  
//         // Verifica si estadoId es válido antes de usarlo
//         if (estadoId && stateCounts[estadoId] !== undefined) {
//           stateCounts[estadoId]++;
//         }
//       });
//     });
  
//     // Devuelve los conteos en el orden de los estados
//     return Object.keys(estadoMap).map((key) => stateCounts[key]);
//   }
  
  

//   function onToggleTypeModal() {
//     const isOpen =
//       dynamicModalObj.chartType === 'label' && dynamicModalObj?.type === 'chart-type'
//         ? !dynamicModalObj.isOpen
//         : true;
//     const { x, y } = elModalBtn.current.getClientRects()[0];
//     setDynamicModalObj({
//       isOpen,
//       pos: { x: x - 110, y: y + 20 },
//       type: 'chart-type',
//       chartType: 'label',
//       setChartType,
//     });
//   }

//   function getChart(chartType) {
//     switch (chartType) {
//       case 'pie':
//         return <Pie data={data} />;
//       case 'bar':
//         return <Bar data={data} />;
//       case 'doughnut':
//         return <Doughnut data={data} />;
//       default:
//         return null;
//     }
//   }

//   return (
//     <section className="label-chart">
//       <div className="chart-header">
//         <div className="header-content">
//           <h2>Estados de Actividades</h2>
//           <span className="icon-container" ref={elModalBtn} onClick={onToggleTypeModal}>
//             <BiDotsHorizontalRounded />
//           </span>
//         </div>
//       </div>
//       <div className="chart-content">{getChart(chartType)}</div>
//     </section>
//   );
// }


import React, { useRef, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar, Doughnut, Pie } from 'react-chartjs-2';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { setDynamicModalObj } from '../../store/board.actions';
import { useSelector } from 'react-redux';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export function LabelChart({ board, dynamicModalObj }) {
  const elModalBtn = useRef();
  const [chartType, setChartType] = useState('bar');

  const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
  const StatusOptions = DataInfo?.statusOptions || [];

  // Mapeo de estados
  const estadoMap = StatusOptions.reduce((map, status) => {
    map[status.id_estado_actividad] = status.descripcion;
    return map;
  }, {});
  

  const data = {
    labels: StatusOptions.map((status) => status.descripcion),
    datasets: [
      {
        label: 'Estados de actividades',
        data: getData(),
        backgroundColor: getLabelColors(),
        borderColor: getLabelColors(),
        borderWidth: 1,
      },
    ],
  };

  function getLabelColors() {
    return StatusOptions.map((status) => status.color);
  }

  function getInitialStateCounts() {
    return StatusOptions.reduce((counts, status) => {
      counts[status.id_estado_actividad] = 0;
      return counts;
    }, {});
  }
  

  function getData() {
    // Inicializa los conteos de estados dinámicamente
    const stateCounts = getInitialStateCounts();
  
    // Recorre los grupos y actividades para contar los estados
    board.forEach((group) => {
      group.actividades.forEach((actividad) => {
        const estadoId = actividad.fk_estado_id;
  
        // Verifica si estadoId es válido antes de usarlo
        if (estadoId && stateCounts[estadoId] !== undefined) {
          stateCounts[estadoId]++;
        }
      });
    });
  
    // Devuelve los conteos en el orden de los estados dinámicos
    return StatusOptions.map((status) => stateCounts[status.id_estado_actividad] || 0);
  }
  
  

  function onToggleTypeModal() {
    const isOpen =
      dynamicModalObj.chartType === 'label' && dynamicModalObj?.type === 'chart-type'
        ? !dynamicModalObj.isOpen
        : true;
    const { x, y } = elModalBtn.current.getClientRects()[0];
    setDynamicModalObj({
      isOpen,
      pos: { x: x - 110, y: y + 20 },
      type: 'chart-type',
      chartType: 'label',
      setChartType,
    });
  }

  function getChart(chartType) {
    switch (chartType) {
      case 'pie':
        return <Pie data={data} />;
      case 'bar':
        return <Bar data={data} />;
      case 'doughnut':
        return <Doughnut data={data} />;
      default:
        return null;
    }
  }

  return (
    <section className="label-chart">
      <div className="chart-header">
        <div className="header-content">
          <h2>Estados de Actividades</h2>
          <span className="icon-container" ref={elModalBtn} onClick={onToggleTypeModal}>
            <BiDotsHorizontalRounded />
          </span>
        </div>
      </div>
      <div className="chart-content">{getChart(chartType)}</div>
    </section>
  );
}

